/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Architect_Detail9Inputs */

const en_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose model, retrieval, caching, and streaming strategy.`)
};

const ar_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر النموذج والاسترجاع والتخزين المؤقت واستراتيجية البث.`)
};

const bn_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মডেল, রিট্রিভাল, ক্যাশিং ও স্ট্রিমিং স্ট্র্যাটেজি বেছে নিন।`)
};

const de_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie Modell, Abruf, Caching und Streaming-Strategie.`)
};

const es_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija modelo, recuperación, almacenamiento en caché y estrategia de transmisión.`)
};

const fr_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez la stratégie de modèle, de récupération, de mise en cache et de streaming.`)
};

const pt_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha modelo, recuperação, cache e estratégia de streaming.`)
};

const zh_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择模型、检索、缓存和流策略。`)
};

const tr_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model, getirme, önbellekleme ve akış stratejisini seçin.`)
};

const ru_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите модель, стратегию ретривала, кэширования и стриминга.`)
};

const pl_svc_ai_integration_architect_detail9 = /** @type {(inputs: Svc_Ai_Integration_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz model, pobieranie, buforowanie i strategię przesyłania strumieniowego.`)
};

/**
* | output |
* | --- |
* | "Choose model, retrieval, caching, and streaming strategy." |
*
* @param {Svc_Ai_Integration_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_architect_detail9 = /** @type {((inputs?: Svc_Ai_Integration_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_ai_integration_architect_detail9(inputs)
	if (locale === "de") return de_svc_ai_integration_architect_detail9(inputs)
	if (locale === "es") return es_svc_ai_integration_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_ai_integration_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_ai_integration_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_ai_integration_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_ai_integration_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_ai_integration_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_ai_integration_architect_detail9(inputs)
	return en_svc_ai_integration_architect_detail9(inputs)
});
export { svc_ai_integration_architect_detail9 as "svc_ai-integration_ARCHITECT_detail" }